import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ConfigServiceService, ItemSidebar } from 'src/app/services/config-service/config-service.service';
import { LoginService, UserInfo } from 'src/app/services/login/login.service';
import { environment } from 'src/environments/environment';
/***********/

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit {

  userInfo : UserInfo | undefined;
  currentUser : UserInfo | undefined;

  private _generalConfigSidebar :  ItemSidebar[] | undefined;

  _userConfigSidebar: ItemSidebar[] = [];


  viewMenu : boolean = false;

  constructor(private loginService: LoginService, public router: Router, public translate: TranslateService,
              private configurationService: ConfigServiceService) {
    // // console.log(router);
    // // console.log(router.getCurrentNavigation()?.finalUrl?.root.children.primary.segments[1].path);
  }

  async ngOnInit(): Promise<void> {
    this.userInfo = JSON.parse(localStorage.getItem("einvuser") || "");
    //this.currentUser = await this.loginService.getSessionUserInfo();
    this._generalConfigSidebar = await (await this.configurationService.getJSON()).configSidebar;
    // console.log(this.userInfo);
    this._generalConfigSidebar.forEach(c => {
      if(c.allow.includes(this.userInfo!.role)){
        this._userConfigSidebar.push(c);
      }
    })
  }

  changeLanguage(language: any){
    this.translate.setDefaultLang(language);
  }

  async logout(){
    let res = await this.loginService.logout();
    if(res.success){
      localStorage.clear();
      this.router.navigate(['../Login']);
    }
  }
}
